export default __webpack_public_path__ + "static/media/NA.77f9c89a.svg";